module.exports = __webpack_public_path__ + "static/img/fea09.7641426.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/fea09.png
// module id = mM4B
// module chunks = 1